import { cn } from '@src/lib/utils';

import { ProcessFieldFloatField } from './ProcessFieldFloatField';

import { useTranslation } from 'react-i18next';

export function ProcessFieldFloatFieldAiChat({
    className,
    fieldProps,
    placeholder,
    ...props
}: React.ComponentProps<typeof ProcessFieldFloatField>) {
    const { t } = useTranslation();

    return (
        <ProcessFieldFloatField
            {...props}
            placeholder={placeholder ?? t('translation:enterAnswer')}
            className={cn(
                'mb-0! w-full gap-0! [&>label]:mb-0! [&>label]:w-full! [&>label]:border-b [&>label]:border-solid [&>label]:border-(--color-card-text)/10 [&>label]:px-[18px] [&>label]:py-4 [&>label]:text-sm! [&>label]:leading-5! [&>label]:font-medium! [&>.serviceFormMessage]:mx-[18px] [&>.serviceFormMessage]:mb-3 [&>.group]:mx-[18px] [&>.group]:my-3 [&>.group]:w-[calc(100%-36px)]! [&_[data-slot=input-group]]:h-12! [&_[data-slot=input-group]]:rounded-xl! [&_[data-slot=input-group]]:border-0! [&_[data-slot=input-group]]:bg-(--color-ai-file-upload-bg)! [&_[data-slot=input-group]]:shadow-none! [&_[data-slot=input-group]:focus-within]:outline-2! [&_[data-slot=input-group]:focus-within]:outline-solid! [&_[data-slot=input-group]:focus-within]:outline-(--color-brand-green)! [&_[data-slot=input-group][data-error=true]]:outline-1! [&_[data-slot=input-group][data-error=true]]:outline-solid! [&_[data-slot=input-group][data-error=true]]:outline-(--color-danger)!',
                className,
            )}
            fieldProps={{
                ...fieldProps,
                className: cn(
                    'h-full! border-0! bg-transparent! px-4! py-2! text-sm! leading-5! font-medium! text-(--color-card-text)! placeholder:text-(--color-neutral-6)!',
                    fieldProps?.className,
                ),
            }}
        />
    );
}
